var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-main-content",staticStyle:{"padding":"5% 0 0 0 !important"}},[_c('iframe',{staticStyle:{"width":"100vw","height":"800vh"},attrs:{"name":"Support","src":"https://symbiocenter.fr/centre_assistance/"}})])
}]

export { render, staticRenderFns }